import type { I18nLocale } from '@ardoq/i18n';
import type { PolarViewSettings } from '@ardoq/xyz-charts';
import type { FieldOption, NumericField } from 'tabview/chartShared/types';

/** What the view publishes for the settings bar to read. */
export type PolarViewProperties = {
  viewSettings: PolarViewSettings;
  numericFields: NumericField[];
  seriesFields: FieldOption[];
  i18nLocale: I18nLocale;
  isEmptyView: boolean;
  viewInstanceId: string;
};

const POLAR_VIEW_PROPERTIES_KEYS = [
  'viewSettings',
  'numericFields',
  'seriesFields',
  'i18nLocale',
  'isEmptyView',
  'viewInstanceId',
] as const satisfies readonly (keyof PolarViewProperties)[];

export const isPolarViewProperties = (
  viewProperties: Record<string, unknown>
): viewProperties is PolarViewProperties =>
  POLAR_VIEW_PROPERTIES_KEYS.every(key => viewProperties[key] !== undefined);
